import Player from '@vimeo/player';

const playVideo = (event, el, player, type) => {
    event.preventDefault();
    el.classList.add('playing');
    document.body.classList.add('stop-scrolling');

    // Delay for animation
    setTimeout(() => {
        if (type === 'vimeo') {
            player.play();
        } else {
            player.playVideo();
        }
    }, 300);
};

const stopVideo = (event, el, player, type) => {
    event.preventDefault();
    el.classList.remove('playing');
    document.body.classList.remove('stop-scrolling');

    // Delay for animation
    setTimeout(() => {
        if (type === 'vimeo') {
            player.unload();
        } else {
            player.stopVideo();
        }
    }, 300);
};

const initVideoEmbeds = (elements) => {
    elements.forEach((el) => {
        let player;

        const video = el.querySelector('.flexible-video__iframe');
        const openBtn = el.querySelector('.flexible-video__open');
        const closeBtn = el.querySelector('.flexible-video__close');

        if (el.dataset.videoEmbed === 'youtube') {
            let YT;

            const playerReady = () => {
                openBtn.addEventListener('click', (event) => {
                    playVideo(event, el, player, 'youtube');
                });

                closeBtn.addEventListener('click', (event) => {
                    stopVideo(event, el, player, 'youtube');
                });
            };

            window.onYouTubePlayerAPIReady = () => {
                YT = window.YT;

                player = new YT.Player(video, {
                    events: {
                        onReady: playerReady
                    }
                });
            };

            // Inject YouTube API script if it doesn't exist
            const ytScript = document.getElementById('youtubeAPI');

            if (!ytScript) {
                const scriptEl = document.createElement('script');
                scriptEl.src = 'https://www.youtube.com/player_api';
                scriptEl.id = 'youtubeAPI';

                const firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(scriptEl, firstScriptTag);
            }
        } else {
            player = new Player(video);

            openBtn.addEventListener('click', (event) => {
                playVideo(event, el, player, 'vimeo');
            });

            closeBtn.addEventListener('click', (event) => {
                stopVideo(event, el, player, 'vimeo');
            });
        }
    });
};

export default initVideoEmbeds;
